var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyPaySelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25px",
    height: "25px",
    viewBox: "0 0 18.45 27.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t\t.my-pay-cls-1{fill:#fff;}.my-pay-cls-2{fill:#fcbc00;}\n\t\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n\t\tMyPay_Selected\n\t") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "my-pay-cls-1",
    d: "M16.4,22.92H9a7.86,7.86,0,0,0,.91-3.68V7.78A3.68,3.68,0,0,1,13.55,4.1a2.05,2.05,0,0,0,0-4.1A7.79,7.79,0,0,0,5.77,7.78V19.24A3.67,3.67,0,0,1,2.2,22.91a2.09,2.09,0,0,0-1.38.6h0a2,2,0,0,0-.22.27l0,0a1.51,1.51,0,0,0-.15.28l0,.07a2.76,2.76,0,0,0-.08.27l0,.12a2.11,2.11,0,0,0,0,.25c0,.05,0,.1,0,.15a0,0,0,0,0,0,0s0,0,0,0l0,.17a1.46,1.46,0,0,0,0,.22.53.53,0,0,0,0,.12c0,.09,0,.18.09.27a.05.05,0,0,1,0,0A2.05,2.05,0,0,0,2.27,27H16.4a2,2,0,1,0,0-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "my-pay-cls-2",
    d: "M13.6,15.55H2a2,2,0,0,1,0-4.08H13.6a2,2,0,1,1,0,4.08Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPaySelected);
export default __webpack_public_path__ + "static/media/my-pay-selected.42b19f0b3a5a25ec4c401eec0caa4c6e.svg";
export { ForwardRef as ReactComponent };